//
// Picking汎用モデル
//

import React from 'react'

import ServiceMenuTemplate from '../../../../templates/ServiceMenuTemplate'

const PickingGeneralMenu = () => {
  const props = {
    pageTitle: 'opt_picking_list_general',
    upperNavLinkTitle: 'newexec',
    upperNavTo: '/pickinggeneral/newexec',
    lowerNavLinkTitle: 'reshis',
    lowerNavTo: '/pickinggeneral/reshis',
    backTo: '/asoko2menu'
  }

  return <ServiceMenuTemplate props={props} />
}

export default PickingGeneralMenu
